export default __webpack_public_path__ + "static/cafe_36048-dbfdf969635f8b935a407733c96e297a.png";